module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.closeDial),
      expression: "closeDial"
    }],
    staticClass: "dial-modal",
    style: (_vm.dialStyle)
  }, [_c('ul', {
    staticClass: "phone-list"
  }, _vm._l((_vm.phoneList), function(item) {
    return _c('li', {
      staticClass: "item",
      on: {
        "click": function($event) {
          _vm.duyanCall(item.phoneNum)
        }
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticClass: "phone-number"
    }, [_vm._v(_vm._s(item.telNum))]), _vm._v(" "), _c('i', {
      staticClass: "web-icon-callout"
    })])
  })), _vm._v(" "), _c('div', {
    staticClass: "dial-arrow"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13a516ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dial-modal.vue
// module id = 1218
// module chunks = 82